import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

/** Copies text, and says so on the button for a moment. */
const CopyButton = ({ text, label = 'Copy', ariaLabel, sx }) => {
    const [copied, setCopied] = useState(false);
    const timer = useRef(null);
    useEffect(() => () => clearTimeout(timer.current), []);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(text || '');
            setCopied(true);
            clearTimeout(timer.current);
            timer.current = setTimeout(() => setCopied(false), 1500);
        } catch (e) {
            setCopied(false);
        }
    };
    return (
        <Button size="small" startIcon={<ContentCopyIcon />} onClick={copy} disabled={!text} aria-label={ariaLabel} sx={sx}>
            <span aria-live="polite">{copied ? 'Copied' : label}</span>
        </Button>
    );
};

export default CopyButton;
